export const RESTAURANT_FETCHED = 'restaurants.RESTAURANT_FETCHED';
export const RESTAURANT_SELECTED = 'restaurants.RESTAURANT_SELECTED';
export const RESTAURANT_UPDATED_ORDER_TIME = 'restaurants.RESTAURANT_UPDATED_ORDER_TIME';
export const RESTAURANT_COOK_TIME = 'restaurants.RESTAURANT_COOK_TIME';
export const RESTAURANT_CHECK = 'restaurants.RESTAURANT_CHECK';
export const RESTAURANT_SELECTED_WITHOUT_FETCH = 'restaurants.RESTAURANT_SELECTED_WITHOUT_FETCH';
export const RESTAURANT_START_FETCH = 'restaurants.RESTAURANT_START_FETCH';
export const RESTAURANT_END_FETCH = 'restaurants.RESTAURANT_END_FETCH';


// WEBPACK FOOTER //
// ./src/types/restaurant.js